import moment from "moment/moment";
import React, { useState } from "react";
import { Modal, Row } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { editIcon, viewIcon } from "../../assets/img";
import CloseIcon from "@mui/icons-material/Close";
import { useLazyCouponsStatusQuery } from "../../redux/api/api";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import AddIcon from "@mui/icons-material/Add";
import Swal from "sweetalert2";

const CouponTransaction = ({
  getCouponTransactionList,
  searchCouponTransaction,
  setCouponTransactionPage,
  CouponTransactionCount,
  listResovle,
  paginationCouponTransaction,
  rowCouponTransaction,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlePageChange = (selectedObject) => {
    setCouponTransactionPage(selectedObject.selected + 1);
  };

  return (
    <div>
      {" "}
      <Row md={12} sm={12} lg={12}>
        <div className="col-md-6 mt-5">
          <label className="table-labels f1">
            Total Count : {paginationCouponTransaction?.total}
          </label>
        </div>
      </Row>
      <div className="d-flex ac-jb">
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) =>
              getCouponTransactionList(searchCouponTransaction, e.target.value)
            }
            value={rowCouponTransaction}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        <div className="mb-2">
          <input
            className="form-control bg-white"
            placeholder="Eg: Coupon code"
            style={{ width: "300px" }}
            onChange={(e) =>
              getCouponTransactionList(e.target.value, rowCouponTransaction)
            }
            value={searchCouponTransaction}
          />
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize text-nowrap">
              <th>S.NO</th>
              <th>Date Of Use</th>
              <th>User Name</th>
              <th>Booking ID</th>
              <th>Coupon Code</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {listResovle?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(paginationCouponTransaction?.current_page - 1) *
                      rowCouponTransaction +
                      ind +
                      1}
                  </td>
                  <td>
                    {" "}
                    {item?.created_at
                      ? moment(item?.created_at).format("DD-MM-YYYY hh:mm a")
                      : "-"}
                  </td>
                  <td>{item?.user?.name}</td>
                  <td>
                    {" "}
                    <button
                      className="link-btn"
                      onClick={() =>
                        navigate("/booked-rooms-view", {
                          state: { data: item },
                        })
                      }
                    >
                      {item?.booking_id}
                    </button>
                  </td>
                  <td>{item?.coupon_info?.coupon_code}</td>
                  <td>{item?.coupon_info?.coupon_amount}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={CouponTransactionCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default CouponTransaction;
